module.exports = __webpack_public_path__ + "media/images/icon-fitness-0da550e0d510fb4c14eddbce56589fe4.png";